import React from "react";
import "../views/stylesheets/style.scss";
import { Config } from "../configurations/config";

const IFrameFile = (props) => {
  let src = props.location.aboutProps
    ? props.location.aboutProps.src
    : Config.tossUrl;
  let title = props.location.aboutProps
    ? props.location.aboutProps.title
    : "tossLive";
  return (
    <div>
      <iframe
        src={src}
        title={title}
        width="100%"
        height="100%"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        className="mt-4 p-3"
      ></iframe>
    </div>
  );
};

export default IFrameFile;
